/* eslint-disable jira/filename-case */
import { createContext, type Context } from 'react';
import noop from 'lodash/noop';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const ProjectRestoreContext: Context<(...args: any[]) => void> = createContext(noop);
